/**
 * Ukrainian — the source of truth for keys of the `partner` namespace. Other languages live in the DB
 * (ui_translations, editable in CRM → Налаштування → Мови); `pnpm export-i18n` writes this dictionary to
 * services/api/xq/i18n/partner.uk.json, which seeds the DB. Placeholders: {name}.
 */
export const uk = {
  'app.name': 'Кабінет партнера',
  'app.loading': 'Завантаження…',
  'app.skip': 'Перейти до вмісту',
  'session.switched': 'В іншій вкладці увійшли як {name}. Тепер ця вкладка теж працює від цього імені.',
  'session.signedOutElsewhere': 'В іншій вкладці вийшли з кабінету. Увійдіть знову.',
  'app.offline': 'Немає інтернету. Показуємо збережене; кроки надішлемо, щойно зʼявиться звʼязок.',

  'nav.main': 'Основна навігація',
  'nav.home': 'Головна',
  'nav.handovers': 'Передачі',
  'nav.cases': 'Справи',
  'nav.trips': 'Рейси',
  'nav.more': 'Ще',

  'common.back': 'Назад',
  'common.retry': 'Спробувати ще раз',
  'common.close': 'Закрити',

  'err.generic': 'Щось пішло не так. Спробуйте ще раз.',
  'err.network': 'Немає звʼязку з сервером. Перевірте інтернет.',
  'err.unauthorized': 'Сесія завершилась. Увійдіть знову.',
  'err.forbidden': 'Для цієї дії недостатньо прав.',
  'err.not_found': 'Не знайдено або доступ закрито.',
  'err.validation': 'Перевірте заповнені поля.',
  'err.conflict': 'Зараз цю дію виконати не можна.',
  'err.rate_limited': 'Забагато спроб. Зачекайте кілька хвилин.',
  'err.vehicle_documents': 'У цієї машини бракує обовʼязкового документа або він прострочений на дату рейсу. Оберіть іншу машину або попросіть офіс додати документ.',
  'err.vehicle_documents_departure': 'Рейс не може виїхати: у машини бракує обовʼязкового документа або він прострочений. Попросіть офіс додати документ.',

  'login.intro': 'Кабінет для партнерів VIA DOMUM: передачі, свої справи, рейси і кроки з фото.',
  'login.email': 'Email / логін',
  'login.password': 'Пароль',
  'login.showPassword': 'Показати пароль',
  'login.totp': 'Код з додатка (2FA)',
  'login.totpHint': 'Відкрийте додаток автентифікації і введіть 6 цифр.',
  'login.org': 'Оберіть компанію',
  'login.orgItem': 'Компанія {n}',
  'login.remember': 'Запамʼятати мене на цьому телефоні',
  'login.submit': 'Увійти',
  'login.busy': 'Входимо…',
  'login.invalid': 'Невірний email або пароль.',
  'login.expired': 'Сесія завершилась (вхід з іншого місця або закінчився час). Увійдіть знову — повернемо на той самий екран; збережені кроки не загубляться.',
  'login.invalidTotp': 'Невірний код. Спробуйте ще раз.',
  'login.suspended': 'Доступ призупинено. Зверніться до керівника компанії.',
  'login.noMembership': 'Цей обліковий запис не належить жодній компанії.',
  'login.orgSuspended': 'Роботу компанії в системі призупинено. Зверніться до VIA DOMUM.',

  'notPartner.title': 'Цей кабінет лише для партнерських компаній',
  'notPartner.body': 'Ви увійшли як співробітник основної компанії. Ваша робота — у CRM.',
  'notPartner.crm': 'Відкрити CRM',
  'notPartner.other': 'Увійти іншим обліковим записом',

  'pwd.title': 'Змініть пароль',
  'pwd.intro': 'Пароль видав адміністратор. Задайте власний — щонайменше 10 символів.',
  'pwd.current': 'Поточний пароль',
  'pwd.new': 'Новий пароль',
  'pwd.repeat': 'Повторіть новий пароль',
  'pwd.short': 'Щонайменше 10 символів.',
  'pwd.mismatch': 'Паролі не збігаються.',
  'pwd.wrong': 'Поточний пароль невірний.',
  'pwd.submit': 'Зберегти пароль',
  'pwd.done': 'Пароль змінено.',

  'home.hello': 'Добрий день, {name}',
  'home.today': 'Сьогодні',
  'home.needStep': 'Передачі в роботі',
  'home.offered': 'Нові передачі',
  'home.cases': 'Свої справи в роботі',
  'home.tripsToday': 'Мої рейси сьогодні',
  'home.tripsNext': 'Сьогодні рейсів немає. Найближчий: {date}',
  'home.next': 'Що зробити зараз',
  'home.allClear': 'Термінових справ немає.',
  'home.newCase': 'Нова справа',
  'home.stepHint': 'Наступний крок: {step}',

  'ho.title': 'Передачі',
  'ho.tab.offered': 'Нові',
  'ho.tab.accepted': 'У роботі',
  'ho.tab.done': 'Завершені',
  'ho.empty.offered': 'Нових передач немає.',
  'ho.empty.accepted': 'Передач у роботі немає.',
  'ho.empty.done': 'Завершених передач ще немає.',
  'ho.from': 'Від: {org}',
  'ho.scope.case': 'Уся справа',
  'ho.scope.transport': 'Перевезення',
  'ho.status.offered': 'Нова',
  'ho.status.accepted': 'У роботі',
  'ho.status.completed': 'Завершена',
  'ho.status.declined': 'Відхилена',
  'ho.status.revoked': 'Відкликана',
  'ho.stage.accepted': 'Прийнято',
  'ho.stage.picked_up': 'Тіло забрано',
  'ho.stage.in_transit': 'У дорозі',
  'ho.stage.delivered': 'Доставлено',
  'ho.noStage': 'Тіло ще не забрано',
  'ho.progress': 'Стан',
  'ho.deceased': 'Померлий',
  'ho.route': 'Маршрут',
  'ho.window': 'Забрати: {from} – {to}',
  'ho.note': 'Примітка від VIA DOMUM',
  'ho.accept': 'Прийняти',
  'ho.decline': 'Відхилити',
  'ho.declineConfirm': 'Відхилити цю передачу? VIA DOMUM отримає сповіщення.',
  'ho.acceptedToast': 'Передачу прийнято.',
  'ho.declinedToast': 'Передачу відхилено.',
  'ho.respondHint': 'Прийняти чи відхилити передачу може керівник або диспетчер компанії.',
  'ho.checklist': 'Документи по справі',
  'ho.docs': 'Документи від VIA DOMUM',
  'ho.myDocs': 'Наші документи',
  'ho.acts': 'Акти і рахунки',
  'ho.act': 'Акт № {n}',
  'ho.invoice': 'Рахунок № {n}',
  'ho.amountFree': 'Сума 0 — безкоштовний тестовий період',
  'ho.trip': 'Рейс',
  'ho.noTrip': 'Рейс ще не привʼязано.',
  'ho.linkTrip': 'Привʼязати рейс',
  'ho.pickTrip': 'Свій рейс',
  'ho.createTrip': 'Створити новий рейс',
  'ho.tripVehicle': 'Машина',
  'ho.vehicleNoDocs': 'Документ машини відсутній або прострочений: {docs}. Рейс на ній не створити — оберіть іншу машину або попросіть офіс додати документ.',
  'ho.vehicleNoDocsShort': 'бракує документів',
  'ho.tripFrom': 'Звідки',
  'ho.tripTo': 'Куди',
  'ho.tripDate': 'Виїзд',
  'ho.tripLinked': 'Рейс привʼязано.',
  'ho.noFreeTrips': 'Немає рейсів без передачі.',

  'cl.missing': 'Бракує',
  'cl.uploaded': 'На перевірці',
  'cl.accepted': 'Є',
  'cl.rejected': 'Відхилено',
  'cl.not_needed': 'Не потрібен',

  'step.title': 'Кроки',
  'step.picked_up': 'Забрав тіло',
  'step.border_crossed': 'Перетнув кордон',
  'step.customs_cleared': 'Пройшов митницю',
  'step.delivered': 'Доставив',
  'step.other': 'Інше',
  'step.moreMenu': 'Інше / митниця',
  'step.empty': 'Кроків ще немає. Натисніть велику кнопку, коли щось зробите.',
  'step.photos': 'Фото: {n}',
  'step.note': 'Коментар (необовʼязково)',
  'step.noPhotoWarn': 'Немає жодного фото. VIA DOMUM краще бачити підтвердження — додайте фото, якщо можна.',
  'step.save': 'Зберегти крок',
  'step.saveNoPhoto': 'Зберегти без фото',
  'step.saving': 'Зберігаємо…',
  'step.saved': 'Крок збережено.',
  'step.retry': 'Повторити',
  'step.failed': 'Не все завантажилось. Натисніть «Повторити».',
  'step.offline': 'Немає звʼязку. Крок збережено на телефоні — надішлемо автоматично.',
  'step.pendingOnline': 'Збережено на телефоні, ще не надіслано: {n}.',
  'step.pendingOffline': 'Немає звʼязку. Кроків на телефоні: {n} — надішлемо самі, щойно зʼявиться мережа.',
  'step.sendNow': 'Надіслати зараз',
  'step.withGps': 'З геолокацією',
  'step.removePhoto': 'Прибрати фото',
  'step.openPhoto': 'Відкрити фото',
  'step.doneAt': 'Зроблено · {at}',
  'step.next': 'Наступний крок',
  'step.byStatus': 'Позначено статусом, без фото',

  'upload.preparing': 'Підготовка',
  'upload.uploading': 'Завантаження',
  'upload.done': 'Готово',
  'upload.failed': 'Помилка',
  'upload.waiting': 'Очікує',
  'upload.progress': 'Завантажено {done} з {total}',

  'cases.title': 'Справи',
  'cases.new': 'Нова справа',
  'cases.empty': 'Своїх справ ще немає.',
  'cases.open': 'У роботі',
  'cases.closed': 'Закриті',

  'case.stage': 'Етап',
  'case.route': 'Маршрут',
  'case.customer': 'Замовник',
  'case.docs': 'Документи',
  'case.noDocs': 'Документів ще немає.',
  'case.addDoc': 'Додати документ або фото',
  'case.next': 'Перевести на етап',
  'case.moved': 'Етап змінено.',
  'case.blocked': 'Поки не можна: {reason}',
  'case.uploaded': 'Документ додано.',

  'caseNew.title': 'Нова справа',
  'caseNew.service': 'Послуга',
  'caseNew.deceased': 'ПІБ померлого',
  'caseNew.origin': 'Звідки: країна',
  'caseNew.originPlace': 'Звідки: місто, місце',
  'caseNew.dest': 'Куди: країна',
  'caseNew.destPlace': 'Куди: місто',
  'caseNew.customer': 'Замовник (необовʼязково)',
  'caseNew.customerName': 'Імʼя замовника',
  'caseNew.customerPhone': 'Телефон замовника',
  'caseNew.submit': 'Створити справу',
  'caseNew.created': 'Справу створено.',
  'caseNew.required': 'Вкажіть ПІБ померлого.',

  'trips.title': 'Рейси',
  'trips.mine': 'Мої рейси',
  'trips.all': 'Усі рейси',
  'trips.empty': 'Рейсів немає.',
  'trips.places': 'Місця: зайнято {used} з {total}',
  'trips.departureBlocked': 'Рейс не зможе виїхати — документ машини відсутній або прострочений: {docs}. Попросіть офіс додати документ.',
  'trips.stops': 'Зупинки',
  'trips.loads': 'У машині',
  'trips.noLoads': 'Машина порожня.',
  'trips.body': 'Тіло',
  'trips.cargo': 'Вантаж',
  'trips.hidden': 'Місце зайняте іншим замовленням',
  'trips.handover': 'За передачею VIA DOMUM',
  'trips.status.planned': 'Заплановано',
  'trips.status.in_progress': 'У дорозі',
  'trips.status.done': 'Завершено',
  'trips.status.cancelled': 'Скасовано',
  'trips.vehicles': 'Машини',

  'veh.title': 'Машини',
  'veh.empty': 'Машин ще немає.',
  'veh.next': 'Найближчий рейс: {route}',
  'veh.free': 'Вільно місць: {n} з {total}',
  'veh.driver': 'Водій: {name}',
  'veh.docsMissing': 'Документ відсутній або прострочений: {docs}. Нові рейси на цій машині не створити.',
  'veh.noTrip': 'Рейсів найближчим часом немає.',

  'more.title': 'Ще',
  'settings.account': 'Обліковий запис',
  'settings.language': 'Мова',
  'settings.geo': 'Геолокація в кроках',
  'settings.geoHint': 'Додавати до кроку координати телефону. Типово вимкнено.',
  'settings.geoDenied': 'Телефон не дав доступу до геолокації. Дозвольте його в налаштуваннях браузера.',
  'settings.password': 'Змінити пароль',
  'settings.version': 'Версія застосунку',
  'settings.logout': 'Вийти',
  'settings.crm': 'Відкрити CRM',
  'settings.crmHint': 'Розширені дії — у CRM з тим самим входом.',
  'role.owner': 'Власник',
  'role.manager': 'Керівник',
  'role.operator': 'Диспетчер',
  'role.accountant': 'Бухгалтер',
  'role.driver': 'Водій',

  'problem.button': 'Проблема / ідея',
  'problem.title': 'Написати VIA DOMUM',
  'problem.kind': 'Що це?',
  'problem.kind.problem': 'Проблема',
  'problem.kind.idea': 'Ідея',
  'problem.subject': 'Коротко',
  'problem.body': 'Подробиці (необовʼязково)',
  'problem.attach': 'Додати цей екран (сторінка, версія, мова)',
  'problem.send': 'Надіслати',
  'problem.thanks': 'Дякуємо, передано VIA DOMUM',
  'problem.required': 'Напишіть коротко, що сталося.',

  'photo.camera': 'Камера',
  'photo.gallery': 'Галерея',
  'photo.jpegHint': 'Фото стискаємо до JPEG (.jpg), щоб надсилалось швидше.',
} as const;

export type DictKey = keyof typeof uk;
export type Dict = Record<DictKey, string>;
